"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeliveryForm = void 0;
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const common_types_1 = require("@as-react/common-types");
const react_i18next_1 = require("react-i18next");
const i18nConstants_1 = require("../../../constants/i18nConstants");
const common_components_1 = require("@as-react/common-components");
const react_router_1 = require("react-router");
const SessionStorageUtil_1 = tslib_1.__importDefault(require("../../../util/SessionStorageUtil"));
const CheckoutDeliveryContext_1 = require("../../../context/CheckoutDeliveryContext");
const andes_react_1 = require("@yonderland/andes-react");
const BuyFormUtil_1 = require("../../../util/BuyFormUtil");
const StorageKeysConstants_1 = require("../../../constants/StorageKeysConstants");
const common_queries_1 = require("@as-react/common-queries");
const react_query_1 = require("@tanstack/react-query");
const axios_1 = require("axios");
const BasketUtil_1 = tslib_1.__importDefault(require("../../../util/BasketUtil"));
const react_1 = require("react");
const react_hook_form_1 = require("react-hook-form");
const Yup = tslib_1.__importStar(require("yup"));
const yup_1 = require("@hookform/resolvers/yup");
const addressFields_utils_1 = require("../../form/address-fields/addressFields.utils");
const URLParamUtil_1 = require("../../../util/URLParamUtil");
const useScrollToFirstFormError_1 = require("../../form/hooks/useScrollToFirstFormError");
const CustomerUtil_1 = tslib_1.__importDefault(require("../../../util/CustomerUtil"));
const CustomerDetailsFields_utils_1 = require("../../form/registration-fields/CustomerDetailsFields.utils");
const CheckoutContext_1 = require("../../../context/CheckoutContext");
const invoiceFields_utils_1 = require("../../form/invoice-fields/invoiceFields.utils");
const common_utils_1 = require("@as-react/common-utils");
const DeliveryForm_utils_1 = require("./DeliveryForm.utils");
const DeliveryForm = ({ children }) => {
    const { t } = (0, react_i18next_1.useTranslation)([i18nConstants_1.I18N_NAMESPACES.account, i18nConstants_1.I18N_NAMESPACES.checkout, i18nConstants_1.I18N_NAMESPACES.general]);
    const { defaultRequestParams, servicesEndpoint, enableFullVatForm, isInAuthorMode, root } = (0, common_components_1.useAemConfig)();
    const history = (0, react_router_1.useHistory)();
    const [{ info, deliveryCountryId, activeDeliveryOption, homeDelivery, collectStore }, dispatch] = (0, CheckoutDeliveryContext_1.useDeliveryState)();
    const { deliveryForm: { hideInvoice, showMobilePhoneNumber: showPhoneNumberAEMCheckbox }, } = (0, CheckoutContext_1.useCheckoutConfig)();
    const isProviderPostNL = (activeDeliveryOption === null || activeDeliveryOption === void 0 ? void 0 : activeDeliveryOption.provider) === common_types_1.Provider.POSTNL;
    const showMobilePhoneNumber = Boolean(showPhoneNumberAEMCheckbox && (activeDeliveryOption === null || activeDeliveryOption === void 0 ? void 0 : activeDeliveryOption.showPhoneNumber));
    const queryClient = (0, react_query_1.useQueryClient)();
    const { postDeliveryOption, postDelivery } = (0, common_queries_1.checkoutMutations)({
        servicesEndpoint,
        defaultRequestParams,
    });
    const { mutateAsync: postDeliveryOptionMutation } = (0, react_query_1.useMutation)(postDeliveryOption);
    const { mutate: postDeliveryMutation, isPending, isError } = (0, react_query_1.useMutation)(postDelivery);
    const isInvoiceEnabled = CustomerUtil_1.default.isInvoiceEnabled(hideInvoice, info);
    const toggleFieldName = enableFullVatForm ? 'needInvoice' : 'alternateInvoiceAddress';
    const validationSchema = Yup.object({
        chosenDeliveryOption: Yup.string(),
        customer: isProviderPostNL
            ? (0, CustomerDetailsFields_utils_1.getCustomerDetailsValidationSchema)({ t })
                .concat((0, addressFields_utils_1.getAddressValidationSchema)({ t, country: info.country, prefix: 'address.' }))
                .when('chosenDeliveryOption', {
                is: (value) => !CustomerUtil_1.default.isDeliveredToDeliveryAddress(value, info),
                then: schema => schema,
                otherwise: schema => schema.strip(),
            })
            : (0, CustomerDetailsFields_utils_1.getCustomerDetailsValidationSchema)({ t }).when('chosenDeliveryOption', {
                is: (value) => !CustomerUtil_1.default.isDeliveredToDeliveryAddress(value, info),
                then: schema => schema,
                otherwise: schema => schema.strip(),
            }),
        delivery: Yup.object({
            address: (0, DeliveryForm_utils_1.getDeliveryAddressValidationSchema)({ t, country: info.country }).concat((0, CustomerDetailsFields_utils_1.getPhoneNumbersValidationSchema)({ t, shouldValidate: showMobilePhoneNumber })),
            saveAddress: Yup.boolean(),
        }).when('chosenDeliveryOption', {
            is: (value) => CustomerUtil_1.default.isDeliveredToDeliveryAddress(value, info),
            then: schema => schema,
            otherwise: schema => schema.strip(),
        }),
        needInvoice: Yup.boolean(),
        alternateInvoiceAddress: Yup.boolean(),
        invoice: Yup.object().when([toggleFieldName, 'chosenDeliveryOption'], {
            is: (value, chosenDeliveryOption) => value &&
                isInvoiceEnabled &&
                (CustomerUtil_1.default.isDeliveredToDeliveryAddress(chosenDeliveryOption, info) ||
                    chosenDeliveryOption === common_types_1.DeliveryOptionsEnum.PICKUP_POINT),
            then: () => (0, invoiceFields_utils_1.getInvoiceValidationSchema)({
                t,
                country: info.country,
                fullVatFormEnabled: enableFullVatForm,
            }),
        }),
    });
    const setFormValues = (newValues, idCountry, address) => (0, DeliveryForm_utils_1.getInitialValues)(newValues, (0, common_utils_1.mergeObjectDeep)(DeliveryForm_utils_1.initialValuesDeliveryForm, {
        delivery: { address: { idCountry: idCountry } },
        customer: { address: { idCountry: idCountry } },
        invoice: { address: { idCountry: idCountry } },
        idCountry: idCountry,
    }), address, activeDeliveryOption === null || activeDeliveryOption === void 0 ? void 0 : activeDeliveryOption.name, idCountry);
    const formProps = (0, react_hook_form_1.useForm)({
        defaultValues: () => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
            var _a;
            const data = queryClient.getQueryData(common_queries_1.checkoutQueryKeys.getDeliveryInfo());
            const idCountry = (data === null || data === void 0 ? void 0 : data.idCountry) || deliveryCountryId;
            return setFormValues(data, idCountry, idCountry === ((_a = homeDelivery.selectedAddress) === null || _a === void 0 ? void 0 : _a.idCountry) ? homeDelivery.selectedAddress : undefined);
        }),
        mode: 'onTouched',
        shouldFocusError: true,
        resolver: (0, react_1.useMemo)(() => validationSchema && (0, yup_1.yupResolver)(validationSchema), [validationSchema]),
    });
    (0, react_1.useEffect)(() => {
        const updateDeliveryAddressValues = () => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
            const formValues = formProps.getValues();
            if (!formValues.delivery) {
                return;
            }
            const address = (0, DeliveryForm_utils_1.getPreselectedAddress)(Object.assign(Object.assign({}, info), { idCountry: deliveryCountryId }), homeDelivery.selectedAddress);
            const newValues = Object.assign(Object.assign({}, formValues), { delivery: Object.assign(Object.assign({}, formValues.delivery), { address: Object.assign(Object.assign({}, formValues.delivery.address), address) }) });
            formProps.reset(newValues);
            if (homeDelivery.selectedAddress) {
                yield formProps.trigger('delivery.address');
            }
        });
        updateDeliveryAddressValues();
    }, [homeDelivery.selectedAddress]);
    (0, react_1.useEffect)(() => {
        const updateFormValues = () => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
            const address = (0, DeliveryForm_utils_1.getPreselectedAddress)(Object.assign(Object.assign({}, info), { idCountry: info.idCountry }), homeDelivery.selectedAddress);
            const newValues = setFormValues(info, info.idCountry, info.idCountry === (address === null || address === void 0 ? void 0 : address.idCountry) ? address : undefined);
            formProps.reset(newValues);
            if ((0, addressFields_utils_1.hasPrefilledAddress)(address)) {
                yield formProps.trigger('delivery.address');
            }
        });
        if (activeDeliveryOption && CustomerUtil_1.default.isDeliveredToDeliveryAddress(activeDeliveryOption.name, info)) {
            updateFormValues();
        }
    }, [info.idCountry, info.requiresDelivery, activeDeliveryOption === null || activeDeliveryOption === void 0 ? void 0 : activeDeliveryOption.name]);
    (0, useScrollToFirstFormError_1.useScrollToFirstFormError)(formProps.formState, true);
    (0, react_1.useEffect)(() => {
        if (isError) {
            dispatch({ type: 'set_delivery_error', payload: common_types_1.ErrorMessage.API_ERROR });
        }
    }, [isError]);
    if (!info) {
        return null;
    }
    const onSubmit = (values) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
        SessionStorageUtil_1.default.removeItem(StorageKeysConstants_1.GUEST_USER_CHECKOUT_DATA);
        info.chosenDeliveryOption = activeDeliveryOption ? activeDeliveryOption.name : info.chosenDeliveryOption;
        const deliveryForm = (0, DeliveryForm_utils_1.createDeliveryForm)(info, values);
        switch (info.chosenDeliveryOption) {
            case common_types_1.DeliveryOptionsEnum.HOME_DELIVERY:
            case common_types_1.DeliveryOptionsEnum.NAMED_DAY:
            case common_types_1.DeliveryOptionsEnum.NEXT_DAY:
                deliveryForm.updateHomeDeliveryData(values, homeDelivery.selectedAddress).updateInvoiceData(values);
                if (showMobilePhoneNumber) {
                    deliveryForm.updatePhoneNumberData(values);
                }
                break;
            case common_types_1.DeliveryOptionsEnum.COLLECT_STORE:
                deliveryForm.updateCollectStoreData(values, collectStore.selectedStore);
                break;
            case common_types_1.DeliveryOptionsEnum.PICKUP_POINT:
                deliveryForm.updatePickupPointData(values, isProviderPostNL).updateInvoiceData(values);
                break;
            default:
                deliveryForm.updateCustomerDeliveryData(values);
                break;
        }
        if (info.chosenDeliveryOption) {
            try {
                yield postDeliveryOptionMutation(info.chosenDeliveryOption);
            }
            catch (error) {
                if ((0, axios_1.isAxiosError)(error) && BasketUtil_1.default.isBasketNotInitialized(error)) {
                    location.href = `${root}checkout/basket-overview.html`;
                }
            }
        }
        postDeliveryMutation(deliveryForm.data, {
            onSuccess: () => {
                queryClient.refetchQueries({
                    queryKey: common_queries_1.checkoutQueryKeys.getPaymentInfo(),
                    stale: false,
                });
                history.push((0, URLParamUtil_1.generatePathUrl)(root, `buy.html/${common_types_1.RoutePathname.PAYMENT}`, isInAuthorMode));
            },
            onError: error => {
                var _a;
                if ((0, axios_1.isAxiosError)(error)) {
                    if (BasketUtil_1.default.isBasketNotInitialized(error)) {
                        location.href = `${root}checkout/basket-overview.html`;
                        return;
                    }
                    if ((_a = error.response) === null || _a === void 0 ? void 0 : _a.data.find((item) => item.code === 'non_numeric_field')) {
                        dispatch({ type: 'set_delivery_error', payload: common_types_1.ErrorMessage.INVALID_POSTAL_CODE });
                    }
                    else {
                        if ((0, BuyFormUtil_1.isUkCountry)(deliveryForm.data.country)) {
                            dispatch({ type: 'set_delivery_error', payload: common_types_1.ErrorMessage.GENERAL_ADDRESS_BUY });
                        }
                        else {
                            dispatch({ type: 'set_delivery_error', payload: common_types_1.ErrorMessage.API_ERROR });
                        }
                    }
                }
            },
        });
    });
    const getButtonState = () => {
        if (isPending) {
            return 'loading';
        }
        if (!activeDeliveryOption && info.requiresDelivery) {
            return 'disabled';
        }
        return 'interactive';
    };
    return ((0, jsx_runtime_1.jsx)(react_hook_form_1.FormProvider, Object.assign({}, formProps, { children: (0, jsx_runtime_1.jsxs)("form", { noValidate: true, name: "checkout-delivery-details-form", style: { display: 'contents' }, children: [children, (0, jsx_runtime_1.jsx)(andes_react_1.CheckoutLayout.Sticky, { children: (0, jsx_runtime_1.jsx)(andes_react_1.Grid, { columns: 12, children: (0, jsx_runtime_1.jsx)(andes_react_1.Grid.Cell, { span: { xs: 12, lg: 4 }, offset: { lg: 9 }, children: (0, jsx_runtime_1.jsx)(andes_react_1.ButtonAlpha, { fullWidth: true, state: getButtonState(), text: t(`${i18nConstants_1.I18N_NAMESPACES.checkout}:checkout.delivery.submit`), theme: "branded", type: "submit", onClick: formProps.handleSubmit(onSubmit), testId: "delivery_submit" }) }) }) })] }) })));
};
exports.DeliveryForm = DeliveryForm;
